export default {
  // 通用
  common: {
    back: '返回',
    confirm: '确认',
    continue: '继续',
    cancel: '取消',
    retry: '重试',
    total: '合计',
    profile: '个人中心',
    history: '历史记录',
    pleaseLogin: '请先登录',
    my: '我的',
    appName: 'AI智能点餐',
    loading: '加载中...',
    lang: "选择语言",
    loadFailed: '加载失败',
    operationFailed: '操作失败',
    notSet: '未设置',
    country: '国家',
    all: '全部',
    searchPlaceholder: '搜索占位',
    noMore: '没有更多了'
  },

  // 首页
  home: {
    allFoods: '全部美食',
    headline: {
      sub: '你所不知道的',
      main: '{country}美食'
    },
    articleTag: '攻略',
    localGuideTitle: '当地攻略玩法',
    recommendedArticlesAll: '全部',
    hotTopics: '热门美食主题',
    orderCallout: '点餐再也不用 this this 了!',
    mustEatBadge: '必吃榜',
    countrySelect: {
      eyebrow: '旅行目的地',
      title: '请选择国家',
      subtitle: '为你匹配更合适的美食灵感与攻略',
      footer: '可在左上角随时切换'
    },
    loadCountriesFailed: '加载国家失败'
  },

  // 收藏夹
  favorites: {
    title: '收藏夹',
    empty: '暂无收藏',
    foods: '美食',
    articles: '攻略'
  },

  articleList: {
    title: '{country}攻略',
    empty: '暂无推荐攻略'
  },

  // 菜品详情页
  dishDetail: {
    quantity: '数量',
    introduction: '菜品介绍',
    loadingIntroduction: '正在获取菜品介绍...',
    getIntroduction: '获取菜品介绍',
    addToCart: '加入购物车（{count}份）',
    selectQuantity: '请选择数量',
    addedToCart: '已添加{count}份到购物车',
    loadFailed: '获取菜品介绍失败',
    noImage: '暂无图片',
    imageSearchEmpty: '没有找到精准匹配的菜品图片',
    imageSearchAction: '搜索图片',
    aiImageGenerating: 'AI图片生成中',
    generating: '正在生成'
  },

  // 底部导航栏
  tabbar: {
    home: '首页',
    cameraOrder: '拍照点餐',
    favorites: '喜欢',
    profile: '我的',
    camera: '拍照',
    menu: '菜单'
  },

  // 相机页面
  camera: {
    translate: '翻译至',
    takeOrUpload: '点击拍照或上传',
    uploadHint: '支持多张照片，最多9张',
    addMore: '继续添加',
    order: '开始点餐',
    selectLanguage: '选择翻译语言',
    singleMode: '单张模式',
    multiMode: '多张模式',
    history: '历史',
    takePhotoError: '拍照失败，请重试',
    cameraUnsupported: '相机功能不支持',
    cameraPermissionDenied: '相机权限未授权，请在设置中开启',
    capture: '继续拍照',
    tapToCapture: '点击拍照',
    tapToStart: '点击拍照开始',
    readyToCapture: '拍摄菜单',
    uploading: '上传中...',
    uploadFailed: '上传失败',
    pleaseCapture: '请先拍摄照片',
    maxPhotosReached: '最多可拍摄9张照片',
    photosAdded: '已添加{count}张照片',
    confirmUpload: '确认上传',
    uploadMessage: '将上传{count}张照片进行菜单识别',
    startRecognition: '开始识别',
    confirmRecognition: '确认识别',
    willRecognize: '将识别 {count} 张菜单照片',
    continueShooting: '继续拍摄',
    prepareUpload: '准备上传...',
    compressingImage: '正在压缩图片...',
    compressionFailed: '压缩失败',
    useOriginal: '使用原图',
    takePhoto: '点击拍照',
    selectFromGallery: '从相册选择',
    operationFailed: '操作失败，请重试',
    processingPhoto: '正在处理照片...',
    leavingPageWarning: '正在处理照片，确定要离开吗？',
    restoreInfoMissing: '检测到之前拍摄的 {count} 张照片信息，但图片数据丢失，请重新拍摄',
    addedAndSkipped: '已添加 {added} 张，跳过 {skipped} 张非图片文件',
    remainingQuotaNotice: '尊敬的用户{phone}：您当前订阅有效期：{days}',
    guide: {
      step1: '拍摄菜单',
      step2: 'AI识别&翻译',
      step3: '生成菜单'
    }
  },

  // 登录页面
  login: {
    title: '登录',
    phone: '手机号',
    code: '验证码',
    phoneNumber: '手机号',
    verifyCode: '验证码',
    sendCode: '发送验证码',
    resend: '重新发送',
    login: '登录',
    loggingIn: '登录中...',
    success: '登录成功',
    failed: '登录过去，请稍后重试',
    loginSuccess: '登录成功',
    loginFailed: '登录失败',
    phonePlaceholder: '请输入手机号',
    codePlaceholder: '请输入验证码',
    phoneRequired: '请输入手机号',
    codeRequired: '请输入验证码',
    phoneInvalid: '手机号格式不正确',
    codeInvalid: '验证码为4-6位数字',
    phoneError: '手机号格式不正确',
    codeError: '验证码格式不正确',
    codeSent: '验证码已发送',
    resendCode: '重新发送',
    countdown: '{count}秒后重试',
    retryAfter: '{seconds}秒后重试',
    tooFrequent: '发送太频繁，请稍后再试',
    dailyLimit: '今日发送次数已达上限',
    sendFailed: '发送失败，请稍后重试',
    agreeTips: '登录即表示同意用户协议和隐私政策'
  },

  // 菜单页面
  menu: {
    title: '菜单',
    cartTitle: '购物车',
    checkout: '去下单',
    totalItems: '共{count}件',
    clearCart: '清空购物车',
    emptyCart: '购物车为空',
    aiRecommend: 'AI推荐',
    addToCart: '加入购物车',
    viewDetail: '查看详情',
    price: '价格',
    quantity: '数量',
    currentMenu: '当前菜单',
    clearCartConfirm: '确定要清空购物车吗？',
    noMenuData: '请先拍摄菜单',
    confirmButton: '确定',
    cancelButton: '取消',
    hint: '提示',
    noMenuItemsFound: '未识别出菜单项',
  },

  // AI推荐
  ai: {
    recommendedSets: '推荐套餐',
    dishCount: '道菜',
    selectSetHint: '请选择一个推荐套餐',
    noSelectedDishes: '请先选择菜品',
    setPrefix: '套餐',
    others: '其他',
    diningOptions: '用餐偏好',
    numberOfPeople: '用餐人数',
    dietaryPreferences: '饮食偏好',
    budgetRange: '预算范围',
    getRecommendation: 'AI帮我点',
    noSpicy: '不吃辣',
    vegetarian: '素食',
    seafood: '海鲜',
    meat: '肉食',
    loading: '正在生成推荐...',
    recommendationTitle: 'AI为您推荐',
    tastePreference: '口味偏好',
    budgetPerPerson: '人均预算',
    allergyWarning: '饮食限制（过敏源）',
    sweet: '甜味',
    sour: '酸味',
    spicy: '辣味',
    bitter: '苦味',
    umami: '鲜味',
    light: '清淡',
    heavy: '重口',
    dairy: '奶类',
    eggs: '蛋类',
    fish: '鱼类',
    shellfish: '甲壳类动物',
    treeNuts: '木本坚果',
    peanuts: '花生',
    wheat: '小麦',
    soy: '大豆',
    selectOptions: '请选择用餐偏好',
    peopleCountError: '用餐人数必须大于等于1人',
    budgetRangeError: '预算范围必须为正整数',
    budgetMaxMinError: '最高预算必须大于等于最低预算',
    submitFailed: '提交失败，请重试',
    minBudget: '最低预算',
    maxBudget: '最高预算',
    to: '至',
    yuan: '元',
    recommendProgress: 'AI推荐进度',
    analyzing: '正在分析菜单...',
    generating: '正在生成推荐方案...',
    recommendReason: '推荐理由',
    menuCombination: '菜单组合',
    dietaryNotes: '饮食建议',
    servingSize: '建议份数',
    viewDetail: '详情',
    goToCheckout: '去下单',
    dish: '份',
    menuOption: '套餐',
    recommendedDishes: '推荐菜品',
    categoryDishes: '分类菜品',
    order: '点餐',
    orderConversation: '订单对话'
  },

  // 上传页面
  upload: {
    title: '识别中',
    uploading: '上传中...',
    recognizing: '识别菜单中...',
    translating: '翻译中...',
    generating: '生成结果中...',
    complete: '识别完成',
    failed: '识别失败',
    progress: '进度',
    detailsTitle: '识别详情',
    retake: '返回重拍',
    retryUpload: '重试上传',
    buyBenefits: '升级权益',
    uploadingNow: '正在上传',
    aiRecognizingImages: 'AI正在识别图片',
    aiTranslatingMenu: 'AI正在翻译菜单',
    dynamicCompression: '图像动态压缩中',
    ocrEngineIntegration: 'OCR图像识别引擎接入',
    agentEngineBoot: '智能体引擎启动',
    llmContextParsing: 'LLM语境解析',
    ragTargetLanguage: 'RAG匹配目标语言',
    cuisineRegionMapping: '菜系地域映射',
    enhancedTranslation: '增强翻译启动',
    dishMetadataClassification: '菜品元数据分类',
    semanticUiConstruction: '语义UI构建',
    confirmCancelTitle: '确认取消',
    confirmCancelMessage: '确定要取消识别吗？',
    preparingCount: '正在准备 {count} 张照片...',
    startUploadCount: '开始上传 {count} 张照片',
    processingComplete: '处理完成',
    navigatingSoon: '即将跳转...',
    processingCompleteAndNavigate: '处理完成，即将跳转',
    createBackgroundTask: '正在创建后台任务...',
    noPhotoFound: '未找到照片数据',
    pleaseRetake: '请返回重新拍摄',
    dataParseFailed: '数据解析失败',
    photoDataParseFailed: '照片数据解析失败',
    photoDataFormatError: '照片数据格式错误，请返回重新拍摄',
    uploadFailedShort: '上传失败',
    failedShort: '失败',
    errorTryAgain: '处理失败，请重试',
    menuNotFound: '未识别出菜单，请重新拍摄',
    otherLlmErr: '翻译菜单失败',
    finalizing: '正在努力翻译菜单中',
    almostDone: '即将完成，请稍候'
  },

  // 错误信息
  error: {
    network: '网络错误，请检查网络连接',
    server: '服务器错误，请稍后重试',
    timeout: '请求超时，请重试',
    unknown: '未知错误',
    auth: '认证失败，请重新登录',
    selectImage: '请选择图片文件',
    imageTooLarge: '图片不能超过20MB',
    processPhotoFailed: '处理照片失败，请重试',
    processFileFailed: '处理文件失败',
    pageStateError: '页面状态异常，请重新拍照',
    processingPhotos: '正在处理照片，请稍候...',
    livePhotoNotSupported: '请选择普通照片，不支持Live Photo',
    microphonePermissionDenied: '麦克风权限被拒绝，请在浏览器设置中允许',
    microphoneNotFound: '未找到麦克风设备',
    microphoneInUse: '麦克风被其他应用占用',
    microphoneConfigNotSupported: '麦克风不支持请求的配置',
    recordingNotSupported: '浏览器不支持录音功能',
    recordingError: '录音过程中发生错误',
    forbidden: '没有权限访问',
    notFound: '请求的资源不存在',
    requestFailed: '请求失败',
    configError: '请求配置错误'
  },

  // 订单对话页面
  orderConversation: {
    title: '订单对话',
    menu_order: "点餐",
    quantity: '数量',
    translatedText: '翻译文本',
    orderText: '点餐文本',
    userSpeak: '按住说话',
    waiterSpeak: '按住说话',
    customerSpeak: '按住说话',
    waiterSpec: "服务员",
    customerSpec: "顾客",
    dish_detail: "详情",
    recording: '录音中...',
    common_confirm: '确认',
    customerRecording: '顾客录音中...',
    recognizing: '识别中...',
    translating: '翻译中...',
    recordingFailed: '录音失败，请检查麦克风权限',
    recognitionFailed: '语音识别失败',
    translationFailed: '翻译失败',
    recognitionResult: '识别结果',
    blankAudio: "说话时间太短",
    noDishes: '没有选择菜品',
    assistantIntro: '你好，我是顾客的点菜助理APP，顾客想点以下这些菜品。你有什么问题可以按住底部按钮说话，我会翻译转告。'
  },

  // 个人中心
  profile: {
    title: '我的',
    memberCard: {
      title: '会员权益',
      dynamicTitle: '您当前为{status}用户<br />享有的会员权益：',
      feature1: ' 菜单精准识别',
      feature2: ' 20+种语言翻译',
      feature3: ' AI推荐点餐',
      feature4: ' 多国菜品介绍',
      feature5: ' 连续的语音对话翻译',
      featureUsageTemplate: '{feature}（有效{count}）',
      unlock: '立即解锁',
      unlockBenefits: '升级权益套餐'
    },
    menu: {
      privacy: '隐私政策',
      terms: '用户协议',
      feedback: '反馈建议',
      serviceStatus: '服务状态',
      about: '关于'
    },
    redeem: {
      button: '权益兑换',
      title: '权益兑换',
      description: '请输入兑换码，完成权益激活。',
      placeholder: '输入兑换码',
      helper: '支持12位字母和数字组合，字母不区分大小写；可粘贴后自动清理空格。',
      submit: '立即兑换',
      cancel: '取消',
      success: '兑换成功，权益已刷新',
      validation: {
        empty: '请先输入兑换码',
        length: '兑换码需为12位字母和数字组合',
        format: '兑换码格式有误，请检查输入',
        checksum: '兑换码校验失败，请确认后再试'
      }
    },
    register: '注销账号',
    registerHint: '注销功能开发中',
    logout: '退出登录',
    logoutConfirm: {
      title: '退出登录',
      message: '确定要退出登录吗？'
    },
    logoutSuccess: '已退出登录'
  },

  subscription: {
    subtitle: 'AI MENU PASS',
    title: '解锁AI点餐权益',
    columns: {
      feature: '对比列表'
    },
    plans: {
      freeUser: '免费用户',
      trial: '免费试用',
      trialTag: '限时体验',
      oneDay: '1天订阅套餐',
      twoDay: '2天畅享套餐',
      threeDay: '3天畅享套餐',
      fiveDay: '5天畅游套餐'
    },
    actions: {
      tryNow: '点击试用',
      purchase: '点击购买',
      continueTrial: '继续体验',
      trialUnavailable: '试用已用完',
      renew: '立即续费',
      subscribed: '已订阅'
    },
    features: {
      validity: '剩余有效期',
      price: '价格',
      usageCount: '权益次数',
      aiTranslate: 'AI翻译菜单',
      aiTextDetail: '菜品详情\n文字版',
      aiRecommend: 'AI推荐点餐',
      aiOrder: 'AI辅助下单',
      aiVoice: '语音对话翻译'
    },
    values: {
      days: '{count}天',
      lifetime: '长期',
      free: '0',
      price: '{amount} 元人民币',
      times: '{count} 次',
      notAvailable: '-',
      comingSoon: '-（陆续开放中）'
    },
    remarkTitle: '权益说明',
    remarksText:
      '1. 菜单识别翻译覆盖国家：亚洲：日本、韩国、泰国、越南、新加坡、马来西亚、印度尼西亚、阿联酋、土耳其；欧洲：英国、法国、德国、奥地利、瑞士、意大利、爱尔兰、西班牙、葡萄牙、俄罗斯、捷克、匈牙利、克罗地亚、荷兰、罗马尼亚、瑞典；北美洲：美国、加拿大、墨西哥；南美洲：巴西、阿根廷、智利、乌拉圭、巴拉圭、哥伦比亚、委内瑞拉、巴拿马、秘鲁、厄瓜多尔；其他：澳大利亚、新西兰。' +
      '\n备注：瑞士支持德语、法语、意大利语；奥地利仅支持德语；南美洲除巴西以外支持西班牙语。' +
      '\n2. 本公司对页面展示内容及规则拥有解释权，解释应遵循法律法规并保障用户合法权益。',
    toast: {
      trialRedirect: '即将为你跳转，激活完整体验',
      purchaseRedirect: '即将为你跳转购买权益',
      contactAdmin: '请联系管理员开通会员服务',
      noQuota: '您的使用次数已达上限，请前往“我的”页面购买权益',
      subscriptionExpired: '您的会员权益已过期或使用次数已达上限，请前往“我的”页面续费',
      trialExhausted: '您的试用次数已用完，请前往“我的”页面购买会员权益',
      wechatRequired: '请使用微信内置浏览器完成支付',
      paySuccess: '支付成功，权益已刷新',
      payCancelled: '支付已取消',
      payFailed: '支付失败，请稍后重试',
      payPending: '支付结果确认中，请稍后在订单状态中核实',
      productUnavailable: '该商品暂不可购买，请稍后再试'
    },
    currentBenefits: '当前套餐',
    moreDetails: '详情',
    remainingBenefits: '剩余',
    totalBenefits: '总计',
    expireTime: '到期时间',
    tabs: {
      compare: '对比',
      detail: '详情'
    },
    upgradeTitle: '升级套餐',
    trialNoteTitle: '试用说明',
    trialNoteText: '试用会员可体验菜单翻译等功能，试用期间不影响订阅权益。',
    statusDetail: {
      title: '套餐详情',
      planName: '套餐名称',
      startTime: '开始日期',
      expireTime: '到期日期',
      totalCount: '总次数',
      status: '状态',
      statusMap: {
        pending: '待生效',
        active: '生效中',
        invalid: '失效状态'
      }
    },
    durations: {
      oneDay: '1天',
      twoDay: '2天',
      threeDay: '3天',
      fiveDay: '5天'
    },
    subscriptionSuffix: '订阅',
    subscriptionName: '{duration}订阅',
    fiveDayDesc: '5天有效期',
    validityOnly: '{duration}有效期',
    validityAndUsage: '{duration}有效期，包含{usage}的使用权益',
    usageCountSimple: '使用次数'
  }
}
